<template>
  <div class="row">

    <el-drawer title="" :visible.sync="showForm" direction="btt" :before-close="handleClose" size="90%"
      :destroy-on-close="true">
      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-6">
          <client-user-form @save="getUsers()" v-if="showForm" :user="selected"></client-user-form>
        </div>
      </div>

    </el-drawer>

    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">Users</div>
      </div>
      <div class="card-body row">
        <div class="col-sm-6">
          <el-select class="" v-model="pagination.perPage" placeholder="Per page">
            <el-option class="select-default" v-for="item in perPageOptions" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
          <el-select class="" v-model="status" placeholder="Per page">
            <el-option class="select-primary" v-for="item, i in status_list" :key="i" :label="item" :value="i">
            </el-option>
          </el-select>
          <el-select class="" v-model="branch_id" placeholder="Branch">
            <el-option class="select-primary" v-for="(branch, i) in branches" :key="i" :label="branch.name" :value="branch.id">
            </el-option>
          </el-select>
          
          <el-button type="primary" size="small" class="ml-2" @click="handleForm">New +</el-button>
        </div>
        <div class="col-md-2">
           <el-input placeholder="Search by role" v-model="role_name">
            </el-input>
        </div>
        <div class="col-sm-4">
          <div class="pull-right">
            <el-input placeholder="Please input" v-model="term" class="input-with-select">
              <el-button slot="append" icon="el-icon-search" @click="getUsers"></el-button>
            </el-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2" v-loading="loading">
          <el-table class="table-striped" header-row-class-name="text-primary" :data="users" style="width: 100%">
            <el-table-column type="expand">
              <template slot-scope="props">
                <div style="padding-left: 50px">
                  <p>Roles: {{ props.row.role_names.join(", ") }}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-for="column in userColumns" :key="column.label" :min-width="column.minWidth"
              :prop="column.prop" :label="column.label">
            </el-table-column>
            <el-table-column :min-width="120"  class-name="td-actions" label="Roles">
              <template slot-scope="props">
                {{ props.row.role_names }}<br>
              </template>
            </el-table-column>

            <el-table-column :min-width="120"  class-name="td-actions" label="Name">
              <template slot-scope="props">
                {{ props.row.name }}<br>
                {{ props.row.email }}<br>
                {{ props.row.contact_number || 'NO CONTACT NO'}} <br><span>{{ props.row.allow_sms ? 'SMS ALLOWED':'SMS NOT ALLOWED' }}</span>

              </template>
            </el-table-column>

            <el-table-column :min-width="120"  class-name="td-actions" label="Branch">
              <template slot-scope="props">
                {{ props.row.branch ? props.row.branch.name: 'N/A' }}
              </template>
            </el-table-column>

            <el-table-column :min-width="120"  class-name="td-actions" label="Status">
              <template slot-scope="props">
                {{ $store.state.users_status[props.row.status]}}
              </template>
            </el-table-column>

            <el-table-column :min-width="120"  class-name="td-actions" label="Actions">
              <template slot-scope="props">

                <el-button type="default" link @click="handleEdit(props.row)" size="mini">
                  <i class="fa fa-edit"></i>
                </el-button>

                <confirm-delete @onClick="handleDelete(props.row)" :label="''"></confirm-delete>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">Found {{ pagination.total }} data</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right" v-model="pagination.currentPage" :per-page="pagination.perPage"
            :total="pagination.total">
          </p-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ClientUser
} from '@/resources/client_user'

import {
  Branch
} from '@/resources/branch'


import PPagination from 'src/components/UIComponents/Pagination.vue'
import ClientUserForm from './ClientUserForm.vue'
import ConfirmDelete from '../../../Common/ConfirmDelete.vue'


export default {
  components: {
    PPagination,
    ClientUserForm,
    ConfirmDelete,
  },
  data() {
    return {
      showDelete: false,
      showForm: false,
      selected: null,
      users: [],
      perPageOptions: [5, 10, 15],
      pagination: {
        perPage: 10,
        currentPage: 1,
        total: 0
      },
      term: null,
      status_list: ['Pending', 'Active', 'Inactive'],
      status: 1,
      searchQuery: '',
      propsToSearch: ['name', 'email', 'age'],
      userColumns: [
      ],
      branches: [],
      branch_id: null,
      loading: false,
      role_name: null
    }
  },
  watch: {
    status: function () {
      this.getUsers()
    },
    'pagination.perPage': function () {
      if (this.pagination.currentPage == 1) {
        this.getUsers()
      } else {
        this.pagination.currentPage = 1
      }
    },
    'pagination.currentPage': function () {
      this.getUsers()
    },
    branch_id: function(){
      this.getUsers()
    }
  },
  created: function () {
    this.getBranches()
    this.getUsers()
  },
  methods: {
    handleEdit(model) {
      this.showForm = true
      this.selected = Object.assign({}, model)
    },
    handleClose() {
      this.showDelete = false
      this.showForm = false
      this.selected = null
    },
    handleDelete(data) {
      this.showDelete = true
    },
    handleForm() {
      this.showForm = true
    },
    handleDelete(model) {
      this.$loading = true
      this.$loadingText = "Removing"

      ClientUser.delete({ id: model.id })
        .then(result => {
          this.$notify({
            type: 'success',
            title: "Success",
            text: 'User has been removed',
          });
          this.getUsers()
        })
        .catch(() => {

        }).finally(() => {
          this.$loading = false
        })
    },
    getUsers() {
      this.loading = true
      this.handleClose()
      ClientUser.get({
        params: {
          term: this.term,
          status: this.status,
          page: this.pagination.currentPage,
          per_page: this.pagination.perPage,
          branch_id: this.branch_id,
          role_name: this.role_name
        }
      })
        .then(result => {
          if (result.data.users)
            this.users = result.data.users
          this.pagination = result.data.meta
        })
        .catch(() => {


        }).finally(() => {
          this.loading = false
        })
    },
    getBranches() {
      Branch.get({
        params: {
          page: 1,
          per_page: 9999
        }
      })
        .then(result => {
          this.branches = result.data.branches
          this.branches.unshift({name: 'All', id: null});
        })
        .catch(() => {


        }).finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss"></style>
